import * as types from './Constant';

const initialState = {
    requesting: false,
    patientDetails: null,
    slots: null,
    docdetails: null,
    departmentDoctor: null,
    updatedSheduleData : null
};

export default function doctorReducer(state = initialState, action) {
    switch (action.type) {

    case types.PATIENT_DETAILS_GET:
        return {
            ...state,
            requesting: false,
        };

    case types.PATIENT_DETAILS_GET_SUCCESS:
        return {
            ...state,
            patientDetails: action.payload,
            requesting:  false,
        };

    case types.GET_SLOTS_DOC:
        return {
            ...state,
            requesting: true,
        };

    case types.GET_SLOTS_DOC_SUCCESS:
        return {
            ...state,
            slots: action.payload,
            requesting: false,
        };

    case types.DOC_DETAILS_GET_CAMPAIGN:
        return {
            ...state,
            requesting: true,
        };

    case types.DOC_DETAILS_GET_CAMPAIGN_SUCCESS:
        return {
            ...state,
            docdetails: action.payload,
            requesting: false,
        };

    case types.DEPARTMENT_DOC_LISTING:
        return {
            ...state,
            requesting: true,
        };

    case types.DEPARTMENT_DOC_LISTING_SUCCESS:
        return {
            ...state,
            departmentDoctor: action.payload,
            requesting: false,
        };

    case types.FAILED_CAMPAIGN_DOC:
        return {
            ...state,
            requesting: false,
        };
    case types.UPDATE_SCHEDULE_DATA_SLOT:
        return { ...state, loading: true };
    case types.UPDATE_SCHEDULE_DATA_SLOT_SUCCESS:
        return { ...state, updatedSheduleData: action.data, loading: false };
    case types.UPDATE_SCHEDULE_DATA_SLOT_ERROR:
        return { ...state, loading: false };

    default:
        return state;
    }
}
